import {jsx as $6jLPP$jsx, jsxs as $6jLPP$jsxs} from "react/jsx-runtime";
import $6jLPP$reactdomclient from "react-dom/client";
import {unstable_setTextOverflow as $6jLPP$unstable_setTextOverflow} from "polotno/config";
import {createStore as $6jLPP$createStore} from "polotno/model/store";
import {Toolbar as $6jLPP$Toolbar} from "polotno/toolbar/toolbar";
import {Tooltip as $6jLPP$Tooltip} from "polotno/canvas/tooltip";
import {Workspace as $6jLPP$Workspace} from "polotno/canvas/workspace";
import {NhostClient as $6jLPP$NhostClient, NhostProvider as $6jLPP$NhostProvider, useNhostClient as $6jLPP$useNhostClient} from "@nhost/react";
import {ZoomButtons as $6jLPP$ZoomButtons} from "polotno/toolbar/zoom-buttons";
import {PolotnoContainer as $6jLPP$PolotnoContainer, SidePanelWrap as $6jLPP$SidePanelWrap, WorkspaceWrap as $6jLPP$WorkspaceWrap} from "polotno";
import {createContext as $6jLPP$createContext, useState as $6jLPP$useState, useCallback as $6jLPP$useCallback, useContext as $6jLPP$useContext, useEffect as $6jLPP$useEffect, useRef as $6jLPP$useRef, useMemo as $6jLPP$useMemo} from "react";
import {TextSection as $6jLPP$TextSection, PhotosSection as $6jLPP$PhotosSection, ElementsSection as $6jLPP$ElementsSection, BackgroundSection as $6jLPP$BackgroundSection, PagesSection as $6jLPP$PagesSection, LayersSection as $6jLPP$LayersSection, SizeSection as $6jLPP$SizeSection, SidePanel as $6jLPP$SidePanel, SectionTab as $6jLPP$SectionTab} from "polotno/side-panel";
import {t as $6jLPP$t} from "polotno/utils/l10n";
import {observer as $6jLPP$observer} from "mobx-react-lite";
import {useInfiniteAPI as $6jLPP$useInfiniteAPI} from "polotno/utils/use-api";
import {Icon as $6jLPP$Icon, Spinner as $6jLPP$Spinner, Button as $6jLPP$Button, Popover as $6jLPP$Popover, Position as $6jLPP$Position, Menu as $6jLPP$Menu, MenuItem as $6jLPP$MenuItem} from "@blueprintjs/core";
import {registerNextDomDrop as $6jLPP$registerNextDomDrop} from "polotno/canvas/page";
import $6jLPP$videosnapshot from "video-snapshot";
import {getImageSize as $6jLPP$getImageSize} from "polotno/utils/image";
















const $9c63859dff314a95$var$TokenContext = /*#__PURE__*/ (0, $6jLPP$createContext)(null);
const $9c63859dff314a95$export$e5cf4eff53e7947d = ({ children: children, ...props })=>{
    const [token, setToken] = (0, $6jLPP$useState)(props.initialToken);
    const [width, setWidth] = (0, $6jLPP$useState)(props.width);
    const [height, setHeight] = (0, $6jLPP$useState)(props.height);
    const [userId, setUserId] = (0, $6jLPP$useState)(props.userId);
    const setTokenValue = (0, $6jLPP$useCallback)((currentToken)=>{
        setToken(currentToken);
    }, []);
    const setWidthValue = (0, $6jLPP$useCallback)((currentWidth)=>{
        setWidth(currentWidth);
    }, []);
    const setHeightValue = (0, $6jLPP$useCallback)((currentHeight)=>{
        setHeight(currentHeight);
    }, []);
    const setUserIdValue = (0, $6jLPP$useCallback)((currentUserId)=>{
        setUserId(currentUserId);
    }, []);
    const contextValue = {
        userId: userId,
        token: token,
        width: width,
        height: height,
        setToken: setTokenValue,
        setWidth: setWidthValue,
        setHeight: setHeightValue,
        setUserId: setUserIdValue
    };
    return /*#__PURE__*/ (0, $6jLPP$jsx)($9c63859dff314a95$var$TokenContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $9c63859dff314a95$export$31dcd79391e423fe = ()=>{
    const context = (0, $6jLPP$useContext)($9c63859dff314a95$var$TokenContext);
    if (!context) throw new Error('useToken must be used within a TokenProvider');
    return context;
};


const $ae12155e372fc23f$var$AppProvider = ({ children: children, ...props })=>/*#__PURE__*/ (0, $6jLPP$jsx)((0, $9c63859dff314a95$export$e5cf4eff53e7947d), {
        userId: props.userId,
        width: props.width,
        height: props.height,
        initialToken: props.token,
        children: children
    });
var $ae12155e372fc23f$export$2e2bcd8739ae039 = $ae12155e372fc23f$var$AppProvider;










/* eslint-disable @typescript-eslint/no-explicit-any */ 




const $399d5e7981de5b50$var$Image = ({ url: url, credit: credit, onSelect: onSelect, shadowEnabled: shadowEnabled, itemHeight: itemHeight, className: className, onLoad: onLoad, type: type })=>{
    const [isShadowEnabled, setIsShadowEnabled] = (0, $6jLPP$useState)(true);
    (0, $6jLPP$useEffect)(()=>{
        setIsShadowEnabled(!!shadowEnabled);
    }, [
        shadowEnabled
    ]);
    const handleDragStart = ()=>{
        (0, $6jLPP$registerNextDomDrop)(({ x: x, y: y }, a, l)=>{
            onSelect({
                x: x,
                y: y
            }, a, l);
        });
    };
    const handleDragEnd = ()=>{
        (0, $6jLPP$registerNextDomDrop)(null);
    };
    return /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
        className: "polotno-close-panel",
        onClick: ()=>onSelect(),
        children: /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
            style: {
                padding: '5px',
                width: '100%'
            },
            children: /*#__PURE__*/ (0, $6jLPP$jsxs)("div", {
                style: {
                    borderRadius: '5px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: isShadowEnabled ? '0 0 5px rgba(16, 22, 26, 0.3)' : '',
                    background: type === 'video' ? 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6))' : ''
                },
                children: [
                    /*#__PURE__*/ (0, $6jLPP$jsx)("img", {
                        className: className,
                        style: {
                            width: '100%',
                            height: itemHeight != null ? itemHeight : 'auto',
                            cursor: 'pointer',
                            display: 'block',
                            maxHeight: '200px',
                            minHeight: '50px',
                            objectFit: 'contain'
                        },
                        src: url,
                        draggable: true,
                        onDragStart: handleDragStart,
                        onDragEnd: handleDragEnd,
                        onLoad: onLoad
                    }),
                    credit && /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                        style: {
                            position: 'absolute',
                            bottom: '0px',
                            left: '0px',
                            fontSize: '10px',
                            padding: '3px',
                            paddingTop: '10px',
                            textAlign: 'center',
                            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6))',
                            width: '100%',
                            opacity: '0',
                            color: 'white'
                        },
                        className: "credit",
                        children: credit
                    }),
                    type === 'video' && /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                        style: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: '20px',
                            textAlign: 'center',
                            width: '100%',
                            color: 'white'
                        },
                        className: "mmediaType",
                        children: /*#__PURE__*/ (0, $6jLPP$jsx)("i", {
                            className: "fa-regular fa-circle-play"
                        })
                    })
                ]
            })
        })
    });
};
const $399d5e7981de5b50$export$9e2ffb854996ec9f = ({ images: images, onSelect: onSelect, isLoading: isLoading, getPreview: getPreview, loadMore: loadMore, getCredit: getCredit, getImageClassName: getImageClassName, rowsNumber: rowsNumber, crossOrigin: crossOrigin = 'anonymous', shadowEnabled: shadowEnabled, itemHeight: itemHeight, error: error })=>{
    const rowCount = rowsNumber || 2;
    const containerRef = (0, $6jLPP$useRef)(null);
    const timeoutRef = (0, $6jLPP$useRef)(null);
    const imageRows = [];
    for(let i = 0; i < rowCount; i++)imageRows.push((images || []).filter((_, index)=>index % rowCount === i));
    const handleScroll = (e)=>{
        const target = e.target;
        const isScrollable = target.scrollHeight - target.scrollTop - target.offsetHeight < 200;
        if (!isLoading && !error && isScrollable) {
            if (loadMore && !isLoading) loadMore();
        }
    };
    const checkHeight = (0, $6jLPP$useCallback)(()=>{
        const hasImages = images && images.length;
        const isBottom = containerRef.current?.scrollHeight ?? 0 > (containerRef.current?.offsetHeight ?? 0) + 5;
        const allImagesLoaded = Array.from(containerRef.current?.querySelectorAll('img') ?? []).every((img)=>img.complete);
        if (!isBottom && !isLoading && hasImages && allImagesLoaded) {
            if (!timeoutRef.current) timeoutRef.current = window.setTimeout(()=>{
                timeoutRef.current = null;
                if (loadMore && !isLoading) loadMore();
            }, 2000);
        }
    }, [
        images,
        isLoading,
        loadMore
    ]);
    (0, $6jLPP$useEffect)(()=>{
        checkHeight();
        return ()=>{
            window.clearTimeout(timeoutRef.current ?? undefined);
            timeoutRef.current = null;
        };
    }, [
        images?.length,
        isLoading,
        checkHeight
    ]);
    return /*#__PURE__*/ (0, $6jLPP$jsxs)("div", {
        onScroll: handleScroll,
        ref: containerRef,
        style: {
            height: '93%',
            overflow: 'auto'
        },
        children: [
            imageRows.map((row, index)=>/*#__PURE__*/ (0, $6jLPP$jsxs)("div", {
                    style: {
                        width: 100 / rowCount + '%',
                        float: 'left'
                    },
                    children: [
                        row.map((image, idx)=>/*#__PURE__*/ (0, $6jLPP$jsx)($399d5e7981de5b50$var$Image, {
                                url: getPreview(image),
                                onSelect: (position, event, item)=>onSelect(image, position, item, event),
                                credit: getCredit && getCredit(image),
                                crossOrigin: crossOrigin,
                                shadowEnabled: shadowEnabled,
                                itemHeight: itemHeight,
                                className: getImageClassName && getImageClassName(image),
                                onLoad: checkHeight,
                                type: image.mediaType || 'image'
                            }, idx)),
                        isLoading && !error && /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                            style: {
                                padding: '30px'
                            },
                            children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Spinner), {})
                        })
                    ]
                }, index)),
            !isLoading && (!images || !images.length) && !error && /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                children: /*#__PURE__*/ (0, $6jLPP$jsx)("p", {
                    children: (0, $6jLPP$t)('sidePanel.noResults')
                })
            }),
            error && /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                children: /*#__PURE__*/ (0, $6jLPP$jsx)("p", {
                    children: (0, $6jLPP$t)('sidePanel.error')
                })
            })
        ]
    });
};


/**
 * COPY
 */ const $4e97186beadfa4a4$export$54fcccfb59d2fe45 = 'https://uhgcmhbgmvuhtnaryxwr';
const $4e97186beadfa4a4$export$3cd3422a0ecf1626 = 'qiyvrncgq84gar8vgeyvfsadfgvuisufsdifvow8yyt928ylvasry8qvwyrno8YOjkhUYF8655EFJihFYHIY';
const $4e97186beadfa4a4$export$10bca895b2dfc909 = 'uhgcmhbgmvuhtnaryxwr';
const $4e97186beadfa4a4$export$53e2a73fc3191522 = 'sa-east-1' /**
 * AMPLITUDE
 */  // export const GRAPHQL_BASE_URL = 'https://rcspllpedqcxwwixkqbz'
 // export const X_HASURA_ADMIN_SECRET = 'oasuugr923ghoidhas98dyh9132hoibdhas089dh98eg91u2ged798sgd972gr9273rgd9dhaosih8132uhr89yr'
 // export const NHOST_SUBDOMAIN = 'rcspllpedqcxwwixkqbz'
 // export const NHOST_REGION = 'sa-east-1'
;


// eslint-disable-next-line react-refresh/only-export-components
const $12247aa03bf6d4a9$var$TemplatesPanel = (0, $6jLPP$observer)(({ store: store })=>{
    // const [showSameSize, setShowSameSize] = useState<boolean>(true);
    // const { width, height } = useToken();
    const headers = {
        'Content-Type': 'application/json',
        'x-hasura-admin-secret': (0, $4e97186beadfa4a4$export$3cd3422a0ecf1626)
    };
    // load data
    const { data: data, isLoading: isLoading, loadMore: loadMore } = (0, $6jLPP$useInfiniteAPI)({
        fetchFunc: (url)=>fetch(url, {
                headers: headers
            }).then((r)=>r.json()),
        getAPI: ({ page: page })=>{
            const offset = (page - 1) * 20;
            return `${0, $4e97186beadfa4a4$export$54fcccfb59d2fe45}.hasura.sa-east-1.nhost.run/api/rest/allTemplates/${offset}`;
        }
    });
    return /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
        style: {
            height: '100%',
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $399d5e7981de5b50$export$9e2ffb854996ec9f), {
            loadMore: loadMore,
            shadowEnabled: false,
            images: data?.map((data)=>data.pTemplate).flat(),
            getPreview: (item)=>`${0, $4e97186beadfa4a4$export$54fcccfb59d2fe45}.storage.sa-east-1.nhost.run/v1/files/${item.previewFileId}?w=200&q=50&${new Date().getTime()}`,
            isLoading: isLoading,
            onSelect: async (item)=>{
                const url = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.hasura.sa-east-1.nhost.run/api/rest/template/${item.id}`;
                const req = await fetch(url, {
                    headers: headers
                });
                const data = await req.json();
                const json = typeof data.pTemplate_by_pk.json === 'string' ? JSON.parse(data.pTemplate_by_pk.json) : data.pTemplate_by_pk.json;
                // just inject it into store
                store.loadJSON(json);
            },
            rowsNumber: 2
        })
    });
});
const $12247aa03bf6d4a9$export$5b82c5abcb92947a = {
    name: 'custom-templates',
    Tab: (0, $6jLPP$observer)((props)=>/*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$SectionTab), {
            name: (0, $6jLPP$t)('sidePanel.templates'),
            iconSize: 19,
            ...props,
            children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Icon), {
                icon: "column-layout"
            })
        })),
    Panel: $12247aa03bf6d4a9$var$TemplatesPanel
};


/* eslint-disable @typescript-eslint/no-unused-vars */ 











// eslint-disable-next-line react-refresh/only-export-components
const $733e43886562c1d0$var$MediasPanel = (0, $6jLPP$observer)(({ store: store })=>{
    const { token: token, userId: userId } = (0, $9c63859dff314a95$export$31dcd79391e423fe)();
    const nhost = (0, $6jLPP$useNhostClient)();
    const [medias, setMedias] = (0, $6jLPP$useState)([]);
    const [offset, setOffset] = (0, $6jLPP$useState)(0);
    const [totalCount, setTotalCount] = (0, $6jLPP$useState)(0);
    const [isUploading, setUploading] = (0, $6jLPP$useState)(false);
    const [loadingMore, setLoadingMore] = (0, $6jLPP$useState)(false);
    (0, $6jLPP$useEffect)(()=>{
        nhost.storage.setAccessToken(token);
        nhost.graphql.setAccessToken(token);
    }, [
        nhost.graphql,
        nhost.storage,
        token
    ]);
    const headers = (0, $6jLPP$useMemo)(()=>({
            'Content-Type': 'application/json',
            'x-hasura-admin-secret': (0, $4e97186beadfa4a4$export$3cd3422a0ecf1626)
        }), []);
    const loadImages = (0, $6jLPP$useCallback)(async ()=>{
        setLoadingMore(true);
        setMedias([]);
        const url = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.hasura.sa-east-1.nhost.run/api/rest/usermedias/0/${userId}`;
        try {
            const response = await fetch(url, {
                headers: headers
            });
            const json = await response.json();
            const currentMedias = [];
            for (const item of json.userMedia){
                const publicUrl = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.storage.sa-east-1.nhost.run/v1/files/${item.fileId}?w=200&q=50&${new Date().getTime()}`;
                currentMedias.push({
                    ...item,
                    presignedUrl: publicUrl
                });
            }
            setTotalCount(json.userMedia_aggregate.aggregate.count);
            setMedias(currentMedias);
        } catch (error) {
            console.error('Erro ao carregar imagens:', error);
        } finally{
            setLoadingMore(false);
        }
    }, [
        headers,
        userId
    ]);
    const loadMore = (0, $6jLPP$useCallback)(async ()=>{
        if (!loadingMore && medias.length < totalCount) {
            setLoadingMore(true);
            const nextPageOffset = offset + 1;
            const url = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.hasura.sa-east-1.nhost.run/api/rest/usermedias/${nextPageOffset * 20}/${userId}`;
            try {
                const response = await fetch(url, {
                    headers: headers
                });
                const json = await response.json();
                const updatedMedias = medias;
                for (const item of json.userMedia){
                    const publicUrl = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.storage.sa-east-1.nhost.run/v1/files/${item.fileId}?w=200&q=50&${new Date().getTime()}`;
                    updatedMedias.push({
                        ...item,
                        presignedUrl: publicUrl
                    });
                }
                setMedias(updatedMedias);
                setOffset(nextPageOffset);
            } catch (error) {
                console.error('Erro ao carregar mais imagens:', error);
            } finally{
                setLoadingMore(false);
            }
        }
    }, [
        headers,
        loadingMore,
        medias,
        offset,
        totalCount,
        userId
    ]);
    const generateVideoThumbnail = (0, $6jLPP$useCallback)(async (videoFile)=>{
        const snapshoter = new (0, $6jLPP$videosnapshot)(videoFile);
        const base64 = await snapshoter.takeSnapshot();
        const responseFetch = await fetch(base64);
        const blob = await responseFetch.blob();
        const file = new File([
            blob
        ], 'thumbnail.png', {
            type: 'image/png'
        });
        const { fileMetadata: fileMetadata, error: uploadError } = await nhost.storage.upload({
            file: file
        });
        if (uploadError) {
            console.error('Erro ao fazer upload:', uploadError);
            return null;
        }
        return fileMetadata.id;
    }, [
        nhost.storage
    ]);
    const handleInsertUserMedia = (0, $6jLPP$useCallback)(async ({ fileId: fileId, videoFileId: videoFileId, mediaType: mediaType })=>{
        const mutation = `
      mutation InsertUserMedia($fileId: uuid!, $videoFileId: uuid,  $mediaType: String) {
        insert_userMedia_one(object: {
          fileId: $fileId
          mediaType: $mediaType
          videoFileId: $videoFileId
        }) {
          id
          fileId
          mediaType
          videoFileId
        }
      }
    `;
        const variables = {
            fileId: fileId,
            mediaType: mediaType,
            videoFileId: videoFileId
        };
        const { error: error } = await nhost.graphql.request(mutation, variables);
        if (error) {
            console.error('Erro ao inserir registro:', error);
            return;
        }
    }, [
        nhost.graphql
    ]);
    const handleFileInput = (0, $6jLPP$useCallback)(async (event)=>{
        if (!event.target.files) return;
        setUploading(true);
        const files = event.target.files;
        for (const file of files){
            const { fileMetadata: fileMetadata, error: uploadError } = await nhost.storage.upload({
                file: file,
                bucketId: 'public'
            });
            if (uploadError) {
                console.error('Erro ao fazer upload:', uploadError);
                return;
            }
            // Verifica se o arquivo é um vídeo para gerar a thumbnail
            if (file.type.startsWith('video/')) {
                const thumbnailFileId = await generateVideoThumbnail(file);
                if (!thumbnailFileId) {
                    console.error('Erro ao gerar thumbnail');
                    return;
                }
                await handleInsertUserMedia({
                    fileId: thumbnailFileId,
                    videoFileId: fileMetadata.id,
                    mediaType: 'video'
                });
            } else await handleInsertUserMedia({
                fileId: fileMetadata.id,
                videoFileId: null,
                mediaType: 'image'
            });
        }
        event.target.value = '';
        await loadImages();
        setUploading(false);
    }, [
        generateVideoThumbnail,
        handleInsertUserMedia,
        loadImages,
        nhost.storage
    ]);
    (0, $6jLPP$useEffect)(()=>{
        loadImages();
    }, [
        loadImages
    ]);
    return /*#__PURE__*/ (0, $6jLPP$jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
                style: {
                    marginBottom: '20px'
                },
                children: /*#__PURE__*/ (0, $6jLPP$jsxs)("label", {
                    htmlFor: "input-file",
                    children: [
                        /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Button), {
                            icon: "upload",
                            style: {
                                width: '100%'
                            },
                            onClick: ()=>{
                                const inputFile = document.querySelector('#input-file');
                                inputFile?.click();
                            },
                            loading: isUploading,
                            children: "Upload media"
                        }),
                        /*#__PURE__*/ (0, $6jLPP$jsx)("input", {
                            type: "file",
                            id: "input-file",
                            style: {
                                display: 'none'
                            },
                            onChange: handleFileInput,
                            multiple: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $6jLPP$jsx)((0, $399d5e7981de5b50$export$9e2ffb854996ec9f), {
                loadMore: loadMore,
                shadowEnabled: false,
                images: medias,
                getPreview: (media)=>media.presignedUrl,
                isLoading: loadingMore,
                onSelect: async (image, pos)=>{
                    if (image.videoFileId) {
                        const publicUrl = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.storage.sa-east-1.nhost.run/v1/files/${image.videoFileId}`;
                        store.activePage.addElement({
                            type: 'video',
                            src: publicUrl,
                            width: 300,
                            height: 300,
                            x: pos?.x || 0,
                            y: pos?.y || 0
                        });
                    } else {
                        const publicUrl = `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.storage.sa-east-1.nhost.run/v1/files/${image.fileId}?${new Date().getTime()}`;
                        const firstSelected = store.selectedElements[0];
                        if (firstSelected) firstSelected.set({
                            type: 'image',
                            src: publicUrl,
                            width: firstSelected.width,
                            height: firstSelected.height,
                            x: firstSelected.x,
                            y: firstSelected.y
                        });
                        else {
                            const { width: width, height: height } = await (0, $6jLPP$getImageSize)(publicUrl);
                            const x = (pos?.x || store.width / 2) - width / 2;
                            const y = (pos?.y || store.height / 2) - height / 2;
                            store.activePage.addElement({
                                type: 'image',
                                src: publicUrl,
                                width: width,
                                height: height,
                                x: x,
                                y: y
                            });
                        }
                    }
                },
                rowsNumber: 2
            })
        ]
    });
});
const $733e43886562c1d0$export$9154a123adf4e03c = {
    name: 'custom-medias',
    Tab: (0, $6jLPP$observer)((props)=>/*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$SectionTab), {
            name: (0, $6jLPP$t)('sidePanel.media'),
            iconSize: 19,
            ...props,
            children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Icon), {
                icon: "media"
            })
        })),
    Panel: $733e43886562c1d0$var$MediasPanel
};


const $8060d81a5b4adfc2$var$mySections = [
    (0, $12247aa03bf6d4a9$export$5b82c5abcb92947a),
    (0, $733e43886562c1d0$export$9154a123adf4e03c),
    (0, $6jLPP$TextSection),
    (0, $6jLPP$PhotosSection),
    (0, $6jLPP$ElementsSection),
    // UploadSection,
    (0, $6jLPP$BackgroundSection),
    (0, $6jLPP$PagesSection),
    (0, $6jLPP$LayersSection),
    (0, $6jLPP$SizeSection)
];
const $8060d81a5b4adfc2$export$642e51fbbe6d77fb = ({ store: store })=>{
    return /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$SidePanel), {
        store: store,
        sections: $8060d81a5b4adfc2$var$mySections,
        defaultSection: "custom-templates"
    });
};




const $c6ec554fcaf236fd$export$642eab9f6d1da513 = ({ store: store })=>{
    return /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
        children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Popover), {
            position: (0, $6jLPP$Position).BOTTOM_LEFT,
            content: /*#__PURE__*/ (0, $6jLPP$jsxs)((0, $6jLPP$Menu), {
                children: [
                    /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$MenuItem), {
                        text: "Salvar como PDF",
                        icon: "document",
                        onClick: ()=>store.saveAsPDF({
                                fileName: 'copymagico.pdf'
                            })
                    }),
                    /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$MenuItem), {
                        text: "Salvar como imagem",
                        icon: "media",
                        onClick: ()=>store.saveAsImage({
                                fileName: 'copymagico.png'
                            })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Button), {
                icon: "import",
                text: "Baixar",
                minimal: true
            })
        })
    });
};






const $2792e825fefa8c69$export$cb79aa18ac8b4781 = (0, $6jLPP$observer)(({ element: element })=>{
    const { userId: userId } = (0, $9c63859dff314a95$export$31dcd79391e423fe)();
    if (userId && [
        "fb8c4797-f57e-4042-aba4-77e0a16b7d74",
        "25ab2853-9288-43ce-8838-db223ca620df",
        "a316dd73-96c5-4c61-850c-18d93bdca068"
    ].includes(userId) === false) return null;
    return /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
        style: {
            marginRight: '8px',
            marginLeft: '8px',
            width: '200px'
        },
        children: /*#__PURE__*/ (0, $6jLPP$jsxs)("select", {
            className: "form-input !px-3 !py-0",
            style: {
                width: '100%'
            },
            value: element.name,
            onChange: (e)=>{
                element.set({
                    name: e.target.value
                });
            },
            children: [
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "",
                    children: "Selecione"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "product.listPrice",
                    children: "Pre\xe7o Original"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "product.salePrice",
                    children: "Pre\xe7o Por"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "brand.webSite",
                    children: "Site da Marca"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "brand.phone",
                    children: "Telefone da Marca"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "templateTitle",
                    children: "T\xedtulo"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "templateSubtitle",
                    children: "Subt\xedtulo"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "templateDescription",
                    children: "Descri\xe7\xe3o"
                })
            ]
        })
    });
});
const $2792e825fefa8c69$export$f1a6a46600836760 = (0, $6jLPP$observer)(({ element: element })=>{
    const { userId: userId } = (0, $9c63859dff314a95$export$31dcd79391e423fe)();
    if (userId && [
        "fb8c4797-f57e-4042-aba4-77e0a16b7d74",
        "25ab2853-9288-43ce-8838-db223ca620df",
        "a316dd73-96c5-4c61-850c-18d93bdca068"
    ].includes(userId) === false) return null;
    return /*#__PURE__*/ (0, $6jLPP$jsx)("div", {
        style: {
            marginRight: '8px',
            marginLeft: '8px',
            width: '200px'
        },
        children: /*#__PURE__*/ (0, $6jLPP$jsxs)("select", {
            className: "form-input !px-3 !py-0",
            style: {
                width: '100%'
            },
            value: element.name,
            onChange: (e)=>{
                element.set({
                    name: e.target.value
                });
            },
            children: [
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "",
                    children: "Selecione"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "product.imageOneUrl",
                    children: "Imagem"
                }),
                /*#__PURE__*/ (0, $6jLPP$jsx)("option", {
                    value: "product.brand.logoColorfulFileId",
                    children: "Logotipo"
                })
            ]
        })
    });
});


const $edeafd00018ca857$var$nhost = new (0, $6jLPP$NhostClient)({
    subdomain: (0, $4e97186beadfa4a4$export$10bca895b2dfc909),
    region: (0, $4e97186beadfa4a4$export$53e2a73fc3191522),
    graphqlUrl: `${(0, $4e97186beadfa4a4$export$54fcccfb59d2fe45)}.hasura.sa-east-1.nhost.run/v1/graphql`
});
const $edeafd00018ca857$export$86fbec116b87613f = (props)=>{
    return /*#__PURE__*/ (0, $6jLPP$jsx)((0, $ae12155e372fc23f$export$2e2bcd8739ae039), {
        token: props.token,
        width: props.width,
        height: props.height,
        userId: props.userId,
        children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$NhostProvider), {
            nhost: $edeafd00018ca857$var$nhost,
            children: /*#__PURE__*/ (0, $6jLPP$jsxs)((0, $6jLPP$PolotnoContainer), {
                className: "polotno-app-container",
                style: {
                    width: '100%',
                    height: '77vh'
                },
                children: [
                    /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$SidePanelWrap), {
                        children: /*#__PURE__*/ (0, $6jLPP$jsx)((0, $8060d81a5b4adfc2$export$642e51fbbe6d77fb), {
                            store: props.store
                        })
                    }),
                    /*#__PURE__*/ (0, $6jLPP$jsxs)((0, $6jLPP$WorkspaceWrap), {
                        children: [
                            /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Toolbar), {
                                store: props.store,
                                components: {
                                    ActionControls: $c6ec554fcaf236fd$export$642eab9f6d1da513
                                }
                            }),
                            /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$Workspace), {
                                store: props.store,
                                components: {
                                    Tooltip: $6jLPP$Tooltip,
                                    TextFill: (0, $2792e825fefa8c69$export$cb79aa18ac8b4781),
                                    ImageFlip: (0, $2792e825fefa8c69$export$f1a6a46600836760),
                                    TextAiWrite: ()=>null
                                }
                            }),
                            /*#__PURE__*/ (0, $6jLPP$jsx)((0, $6jLPP$ZoomButtons), {
                                store: props.store
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $a25b190ccaa8a4de$var$store = (0, $6jLPP$createStore)({
    key: 'ZRySQwqaiM3YAu3mXiY_',
    showCredit: true
});
$a25b190ccaa8a4de$var$store.addPage();
(0, $6jLPP$unstable_setTextOverflow)('change-font-size');
let $a25b190ccaa8a4de$var$root = null;
const $a25b190ccaa8a4de$export$eb02d1ee0d3cac30 = ({ container: container, ...props })=>{
    if ($a25b190ccaa8a4de$var$root) $a25b190ccaa8a4de$var$root.unmount();
    $a25b190ccaa8a4de$var$root = (0, $6jLPP$reactdomclient).createRoot(container);
    $a25b190ccaa8a4de$var$root.render(/*#__PURE__*/ (0, $6jLPP$jsx)((0, $edeafd00018ca857$export$86fbec116b87613f), {
        store: $a25b190ccaa8a4de$var$store,
        token: props.token,
        width: props.width || '1080',
        height: props.height || '1080',
        userId: props.userId
    }));
    return $a25b190ccaa8a4de$var$store;
};
window.createEditor = $a25b190ccaa8a4de$export$eb02d1ee0d3cac30;


export {$a25b190ccaa8a4de$export$eb02d1ee0d3cac30 as createEditor};
